import { SmallBadge } from '@talentmesh/ui/components/badge';
import { cn } from '@talentmesh/ui/lib/utils';
import { LikertOption, Question } from '../../../../../../../../Models/Questions';
import useText from './hardcode/useText';

interface LikertQuestionsPreviewProps {
    demoQuestions: Question[];
    likertOptions: LikertOption[];
}

const getTickClassByScore = (score: number) => {
    switch (score) {
        case 2:
            return 'ring-[#0f9a60]';
        case 1:
            return 'ring-[#20c37f]';
        case -1:
            return 'ring-[#ffc47b]';
        case -2:
            return 'ring-[#c77700]';
        default:
            return 'ring-[#8b8c8c]';
    }
};

const LikertQuestionsPreview = ({ demoQuestions, likertOptions }: LikertQuestionsPreviewProps) => {
    const UIStrings = useText();
    const sortedOptions = [...likertOptions].sort((a, b) => b.score - a.score);
    const colCount = sortedOptions.length;
    const gridTemplateColumns = colCount > 0 ? `minmax(0,2fr) repeat(${colCount + 1}, minmax(0,1fr))` : 'minmax(0,2fr)';

    return (
        <div className="mb-5 flex h-full min-h-0 flex-col overflow-y-auto">
            <div className="bg-muted relative px-6">
                <div className="grid items-center gap-x-2 gap-y-2" style={{ gridTemplateColumns }}>
                    <div className="col-span-2" />
                    {likertOptions.map(({ answerText }) => (
                        <div key={answerText} className="flex justify-center px-1 text-center">
                            <span className="text-foreground max-w-28 py-3 text-base leading-snug">{answerText}</span>
                        </div>
                    ))}
                </div>
                <SmallBadge
                    variant="default"
                    className="border-primary/20 absolute -bottom-5 left-4 z-1 px-3 py-1.5 text-sm font-medium shadow-sm"
                >
                    {UIStrings.PersonalityTestHint}
                </SmallBadge>
            </div>
            <div className="mx-6 my-10 flex flex-col gap-20">
                {demoQuestions.map(({ id, question: questionText }) => (
                    <div key={id} className="grid items-center gap-x-2 gap-y-2" style={{ gridTemplateColumns }}>
                        <div className="text-foreground col-span-2 pr-2 text-base leading-snug">{questionText}</div>
                        {sortedOptions.map(({ score }) => (
                            <div key={score} className="flex justify-center py-1">
                                <span
                                    className={cn('size-7 shrink-0 rounded-full ring-3', getTickClassByScore(score))}
                                    aria-hidden
                                />
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LikertQuestionsPreview;
